import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    name: 'La Bibbia Tecnica',
    desc: 'Il tuo manuale core di 150 pagine.'
  }, {
    name: 'Schemi Tattici',
    desc: 'Rotazioni e sistemi di gioco (P1-P6).'
  }, {
    name: 'Pronto Soccorso',
    desc: 'Prevenzione e gestione infortuni.'
  }, {
    name: 'Scouting Master',
    desc: 'Analisi avanzata degli avversari.'
  }, {
    name: 'Mental Coaching',
    desc: 'Gestione del gruppo e leadership.'
  }, {
    name: 'Pianificazione',
    desc: 'Il tuo roadmap annuale completo.'
  }];
  return <section className="bg-volley-paper py-24 px-4 sm:px-6 lg:px-8" data-id="element-199">
      <div className="max-w-5xl mx-auto" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <div className="bg-volley-navy/10 text-volley-navy-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-202">
            LA SOLUZIONE CHE STAVI ASPETTANDO — UN SISTEMA 6-IN-1
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-4 tracking-tight" data-id="element-203">
            6 guide in 1, progettate esclusivamente per i{' '}
            <span className="italic text-volley-teal" data-id="element-204">
              professionisti del volley
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-205">
          <div className="relative" data-id="element-206">
            <div className="absolute inset-0 bg-volley-teal/10 rounded-3xl blur-2xl transform translate-y-4" data-id="element-207"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jjRs1JqwthzyTRBN5QdTiY/image_(8).webp" alt="Volley Pronto 6-in-1 Box Set" className="relative w-full rounded-3xl shadow-xl border border-white/50" loading="lazy" decoding="async" width="800" height="800" data-id="element-208" />
          </div>

          <div data-id="element-209">
            <p className="text-volley-slate text-lg leading-relaxed mb-8" data-id="element-210">
              <span className="font-bold text-volley-navy" data-id="element-211">VOLLEY PRONTO</span>{' '}
              è molto più di un semplice manuale. È un sistema operativo
              completo che fornisce sessioni professionali, strutturate
              pedagogicamente per garantire fluidità e autorità in palestra.
            </p>

            <ul className="space-y-5" data-id="element-212">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-213">
                  <div className="mt-1 bg-volley-teal/15 p-1.5 rounded-full text-volley-teal-dark flex-shrink-0" data-id="element-214">
                    <Check className="w-4 h-4" strokeWidth={2.5} data-id="element-215" />
                  </div>
                  <div data-id="element-216">
                    <span className="font-bold text-volley-dark text-lg" data-id="element-217">
                      {tomo.name}
                    </span>{' '}
                    <span className="text-volley-slate block sm:inline sm:ml-1" data-id="element-218">
                      — {tomo.desc}
                    </span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}